import api from '../index'

export interface FeedbackCategory {
  id: number
  name: string
  sort: number
  status: 0 | 1
  created_at: string
  updated_at: string
}

export interface FeedbackCategoryListParams {
  page?: number
  page_size?: number
  page_type?: 'page' | 'all'
  status?: 0 | 1
}

export interface FeedbackCategoryCreateData {
  name: string
  sort?: number
  status?: 0 | 1
}

export interface FeedbackCategoryUpdateData {
  name?: string
  sort?: number
  status?: 0 | 1
}

export const feedbackCategoryApi = {
  // 获取反馈类别列表
  list: (params?: FeedbackCategoryListParams) => api.get('feedback-category/list', { params }),

  // 获取反馈类别详情
  detail: (id: number) => api.get(`feedback-category/${id}`),

  // 创建反馈类别
  create: (data: FeedbackCategoryCreateData) => api.post('feedback-category/add', data),

  // 更新反馈类别
  update: (id: number, data: FeedbackCategoryUpdateData) => api.put(`feedback-category/${id}`, data),

  // 删除反馈类别
  delete: (id: number) => api.delete(`feedback-category/${id}`),
}

export default feedbackCategoryApi
